import { Row, Text } from "@hightouch/htui";

type NavGroupLabelProps = {
  children: string;
};

/** A quiet heading over a group of the nav's rows: every section heading takes this one spec. */
export const NavGroupLabel = ({ children }: NavGroupLabelProps) => (
  // 24px above, with the column's gap, sets the section apart, and the gap alone, 8px, sits below it.
  // A 16px box; the text's 20px line overflows it evenly, taking no extra height.
  <Row px={2} mt={4} h={4} align="center" justify="space-between" gap={2}>
    <Text size="sm" fontWeight="medium" color="text.tertiary">
      {children}
    </Text>
  </Row>
);
